/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as OnboardingImport } from './routes/onboarding'
import { Route as IndexImport } from './routes/index'
import { Route as OauthLayoutImport } from './routes/oauth/_layout'
import { Route as ExternalAuthImport } from './routes/external/auth'
import { Route as DashboardsDashboardIdImport } from './routes/dashboards/$dashboardId'
import { Route as DashboardLayoutImport } from './routes/dashboard/_layout'
import { Route as AuthLayoutImport } from './routes/auth/_layout'
import { Route as DashboardLayoutIndexImport } from './routes/dashboard/_layout.index'
import { Route as AuthLayoutIndexImport } from './routes/auth/_layout.index'
import { Route as OauthLayoutGoogleImport } from './routes/oauth/_layout.google'
import { Route as OauthLayoutFacebookImport } from './routes/oauth/_layout.facebook'
import { Route as DashboardsShareShareTokenImport } from './routes/dashboards/share.$shareToken'
import { Route as DashboardSettingsLayoutImport } from './routes/dashboard/settings/_layout'
import { Route as DashboardPaidMediaLayoutImport } from './routes/dashboard/paid-media/_layout'
import { Route as DashboardIntelligenceLayoutImport } from './routes/dashboard/intelligence/_layout'
import { Route as DashboardGovernanceLayoutImport } from './routes/dashboard/governance/_layout'
import { Route as DashboardConsumerResearchLayoutImport } from './routes/dashboard/consumer-research/_layout'
import { Route as DashboardChatSessionImport } from './routes/dashboard/chat/$session'
import { Route as DashboardAiDesignerLayoutImport } from './routes/dashboard/ai-designer/_layout'
import { Route as DashboardLayoutRealTimeAlertsImport } from './routes/dashboard/_layout.real-time-alerts'
import { Route as DashboardLayoutProductsImport } from './routes/dashboard/_layout.products'
import { Route as DashboardLayoutMarketTrackerImport } from './routes/dashboard/_layout.market-tracker'
import { Route as DashboardLayoutLibraryImport } from './routes/dashboard/_layout.library'
import { Route as DashboardLayoutCommunityImport } from './routes/dashboard/_layout.community'
import { Route as DashboardLayoutChatsImport } from './routes/dashboard/_layout.chats'
import { Route as DashboardLayoutBrandImport } from './routes/dashboard/_layout.brand'
import { Route as ChatRSessionImport } from './routes/chat/r.$session'
import { Route as ChatPSessionImport } from './routes/chat/p.$session'
import { Route as DashboardSettingsLayoutUsageImport } from './routes/dashboard/settings/_layout.usage'
import { Route as DashboardSettingsLayoutSubscriptionImport } from './routes/dashboard/settings/_layout.subscription'
import { Route as DashboardSettingsLayoutProfileImport } from './routes/dashboard/settings/_layout.profile'
import { Route as DashboardSettingsLayoutInvoicesImport } from './routes/dashboard/settings/_layout.invoices'
import { Route as DashboardPaidMediaLayoutSchedulesImport } from './routes/dashboard/paid-media/_layout.schedules'
import { Route as DashboardPaidMediaLayoutReportsImport } from './routes/dashboard/paid-media/_layout.reports'
import { Route as DashboardPaidMediaLayoutPlaybookImport } from './routes/dashboard/paid-media/_layout.playbook'
import { Route as DashboardPaidMediaLayoutOverviewV3Import } from './routes/dashboard/paid-media/_layout.overview-v3'
import { Route as DashboardPaidMediaLayoutOverviewImport } from './routes/dashboard/paid-media/_layout.overview'
import { Route as DashboardPaidMediaLayoutDashboardsImport } from './routes/dashboard/paid-media/_layout.dashboards'
import { Route as DashboardPaidMediaLayoutConnectorsImport } from './routes/dashboard/paid-media/_layout.connectors'
import { Route as DashboardPaidMediaLayoutChatImport } from './routes/dashboard/paid-media/_layout.chat'
import { Route as DashboardIntelligenceLayoutOverviewImport } from './routes/dashboard/intelligence/_layout.overview'
import { Route as DashboardIntelligenceLayoutIndustryImport } from './routes/dashboard/intelligence/_layout.industry'
import { Route as DashboardIntelligenceLayoutCreativeAuditImport } from './routes/dashboard/intelligence/_layout.creative-audit'
import { Route as DashboardIntelligenceLayoutCompetitiveImport } from './routes/dashboard/intelligence/_layout.competitive'
import { Route as DashboardIntelligenceLayoutBrandAuditImport } from './routes/dashboard/intelligence/_layout.brand-audit'
import { Route as DashboardIntelligenceLayoutAudienceImport } from './routes/dashboard/intelligence/_layout.audience'
import { Route as DashboardGovernanceLayoutPerformanceBenchmarkImport } from './routes/dashboard/governance/_layout.performance-benchmark'
import { Route as DashboardGovernanceLayoutOverviewImport } from './routes/dashboard/governance/_layout.overview'
import { Route as DashboardGovernanceLayoutCreativeMonitorImport } from './routes/dashboard/governance/_layout.creative-monitor'
import { Route as DashboardGovernanceLayoutComplianceTrackerImport } from './routes/dashboard/governance/_layout.compliance-tracker'
import { Route as DashboardConsumerResearchLayoutSubBrandsImport } from './routes/dashboard/consumer-research/_layout.sub-brands'
import { Route as DashboardConsumerResearchLayoutSocialFeedImport } from './routes/dashboard/consumer-research/_layout.social-feed'
import { Route as DashboardConsumerResearchLayoutRulesImport } from './routes/dashboard/consumer-research/_layout.rules'
import { Route as DashboardConsumerResearchLayoutOverviewImport } from './routes/dashboard/consumer-research/_layout.overview'
import { Route as DashboardConsumerResearchLayoutChannelsImport } from './routes/dashboard/consumer-research/_layout.channels'
import { Route as DashboardConsumerResearchLayoutBrandModeratorImport } from './routes/dashboard/consumer-research/_layout.brand-moderator'
import { Route as DashboardConsumerResearchLayoutAiResearcherImport } from './routes/dashboard/consumer-research/_layout.ai-researcher'
import { Route as DashboardAiDesignerLayoutLibraryImport } from './routes/dashboard/ai-designer/_layout.library'
import { Route as DashboardAiDesignerLayoutCreateImport } from './routes/dashboard/ai-designer/_layout.create'
import { Route as DashboardAiDesignerLayoutAppsImport } from './routes/dashboard/ai-designer/_layout.apps'
import { Route as AuthLayoutCallbackMagicLinkImport } from './routes/auth/_layout.callback.magic-link'
import { Route as AuthLayoutCallbackGoogleImport } from './routes/auth/_layout.callback.google'
import { Route as DashboardConsumerResearchLayoutRulesIndexImport } from './routes/dashboard/consumer-research/_layout.rules.index'
import { Route as DashboardConsumerResearchLayoutRulesCreateImport } from './routes/dashboard/consumer-research/_layout.rules.create'
import { Route as DashboardConsumerResearchLayoutRulesUpdateIdImport } from './routes/dashboard/consumer-research/_layout.rules.update.$id'

// Create Virtual Routes

const OauthImport = createFileRoute('/oauth')()
const DashboardImport = createFileRoute('/dashboard')()
const AuthImport = createFileRoute('/auth')()
const DashboardSettingsImport = createFileRoute('/dashboard/settings')()
const DashboardPaidMediaImport = createFileRoute('/dashboard/paid-media')()
const DashboardIntelligenceImport = createFileRoute('/dashboard/intelligence')()
const DashboardGovernanceImport = createFileRoute('/dashboard/governance')()
const DashboardConsumerResearchImport = createFileRoute(
  '/dashboard/consumer-research',
)()
const DashboardAiDesignerImport = createFileRoute('/dashboard/ai-designer')()

// Create/Update Routes

const OauthRoute = OauthImport.update({
  id: '/oauth',
  path: '/oauth',
  getParentRoute: () => rootRoute,
} as any)

const DashboardRoute = DashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const OnboardingRoute = OnboardingImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardSettingsRoute = DashboardSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardPaidMediaRoute = DashboardPaidMediaImport.update({
  id: '/paid-media',
  path: '/paid-media',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardIntelligenceRoute = DashboardIntelligenceImport.update({
  id: '/intelligence',
  path: '/intelligence',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardGovernanceRoute = DashboardGovernanceImport.update({
  id: '/governance',
  path: '/governance',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardConsumerResearchRoute = DashboardConsumerResearchImport.update({
  id: '/consumer-research',
  path: '/consumer-research',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardAiDesignerRoute = DashboardAiDesignerImport.update({
  id: '/ai-designer',
  path: '/ai-designer',
  getParentRoute: () => DashboardRoute,
} as any)

const OauthLayoutRoute = OauthLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => OauthRoute,
} as any)

const ExternalAuthRoute = ExternalAuthImport.update({
  id: '/external/auth',
  path: '/external/auth',
  getParentRoute: () => rootRoute,
} as any)

const DashboardsDashboardIdRoute = DashboardsDashboardIdImport.update({
  id: '/dashboards/$dashboardId',
  path: '/dashboards/$dashboardId',
  getParentRoute: () => rootRoute,
} as any)

const DashboardLayoutRoute = DashboardLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => DashboardRoute,
} as any)

const AuthLayoutRoute = AuthLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AuthRoute,
} as any)

const DashboardLayoutIndexRoute = DashboardLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const AuthLayoutIndexRoute = AuthLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const OauthLayoutGoogleRoute = OauthLayoutGoogleImport.update({
  id: '/google',
  path: '/google',
  getParentRoute: () => OauthLayoutRoute,
} as any)

const OauthLayoutFacebookRoute = OauthLayoutFacebookImport.update({
  id: '/facebook',
  path: '/facebook',
  getParentRoute: () => OauthLayoutRoute,
} as any)

const DashboardsShareShareTokenRoute = DashboardsShareShareTokenImport.update({
  id: '/dashboards/share/$shareToken',
  path: '/dashboards/share/$shareToken',
  getParentRoute: () => rootRoute,
} as any)

const DashboardSettingsLayoutRoute = DashboardSettingsLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => DashboardSettingsRoute,
} as any)

const DashboardPaidMediaLayoutRoute = DashboardPaidMediaLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => DashboardPaidMediaRoute,
} as any)

const DashboardIntelligenceLayoutRoute =
  DashboardIntelligenceLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => DashboardIntelligenceRoute,
  } as any)

const DashboardGovernanceLayoutRoute = DashboardGovernanceLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => DashboardGovernanceRoute,
} as any)

const DashboardConsumerResearchLayoutRoute =
  DashboardConsumerResearchLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => DashboardConsumerResearchRoute,
  } as any)

const DashboardChatSessionRoute = DashboardChatSessionImport.update({
  id: '/chat/$session',
  path: '/chat/$session',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardAiDesignerLayoutRoute = DashboardAiDesignerLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => DashboardAiDesignerRoute,
} as any)

const DashboardLayoutRealTimeAlertsRoute =
  DashboardLayoutRealTimeAlertsImport.update({
    id: '/real-time-alerts',
    path: '/real-time-alerts',
    getParentRoute: () => DashboardLayoutRoute,
  } as any)

const DashboardLayoutProductsRoute = DashboardLayoutProductsImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const DashboardLayoutMarketTrackerRoute =
  DashboardLayoutMarketTrackerImport.update({
    id: '/market-tracker',
    path: '/market-tracker',
    getParentRoute: () => DashboardLayoutRoute,
  } as any)

const DashboardLayoutLibraryRoute = DashboardLayoutLibraryImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const DashboardLayoutCommunityRoute = DashboardLayoutCommunityImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const DashboardLayoutChatsRoute = DashboardLayoutChatsImport.update({
  id: '/chats',
  path: '/chats',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const DashboardLayoutBrandRoute = DashboardLayoutBrandImport.update({
  id: '/brand',
  path: '/brand',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const ChatRSessionRoute = ChatRSessionImport.update({
  id: '/chat/r/$session',
  path: '/chat/r/$session',
  getParentRoute: () => rootRoute,
} as any)

const ChatPSessionRoute = ChatPSessionImport.update({
  id: '/chat/p/$session',
  path: '/chat/p/$session',
  getParentRoute: () => rootRoute,
} as any)

const DashboardSettingsLayoutUsageRoute =
  DashboardSettingsLayoutUsageImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => DashboardSettingsLayoutRoute,
  } as any)

const DashboardSettingsLayoutSubscriptionRoute =
  DashboardSettingsLayoutSubscriptionImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => DashboardSettingsLayoutRoute,
  } as any)

const DashboardSettingsLayoutProfileRoute =
  DashboardSettingsLayoutProfileImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => DashboardSettingsLayoutRoute,
  } as any)

const DashboardSettingsLayoutInvoicesRoute =
  DashboardSettingsLayoutInvoicesImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => DashboardSettingsLayoutRoute,
  } as any)

const DashboardPaidMediaLayoutSchedulesRoute =
  DashboardPaidMediaLayoutSchedulesImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => DashboardPaidMediaLayoutRoute,
  } as any)

const DashboardPaidMediaLayoutReportsRoute =
  DashboardPaidMediaLayoutReportsImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => DashboardPaidMediaLayoutRoute,
  } as any)

const DashboardPaidMediaLayoutPlaybookRoute =
  DashboardPaidMediaLayoutPlaybookImport.update({
    id: '/playbook',
    path: '/playbook',
    getParentRoute: () => DashboardPaidMediaLayoutRoute,
  } as any)

const DashboardPaidMediaLayoutOverviewV3Route =
  DashboardPaidMediaLayoutOverviewV3Import.update({
    id: '/overview-v3',
    path: '/overview-v3',
    getParentRoute: () => DashboardPaidMediaLayoutRoute,
  } as any)

const DashboardPaidMediaLayoutOverviewRoute =
  DashboardPaidMediaLayoutOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardPaidMediaLayoutRoute,
  } as any)

const DashboardPaidMediaLayoutDashboardsRoute =
  DashboardPaidMediaLayoutDashboardsImport.update({
    id: '/dashboards',
    path: '/dashboards',
    getParentRoute: () => DashboardPaidMediaLayoutRoute,
  } as any)

const DashboardPaidMediaLayoutConnectorsRoute =
  DashboardPaidMediaLayoutConnectorsImport.update({
    id: '/connectors',
    path: '/connectors',
    getParentRoute: () => DashboardPaidMediaLayoutRoute,
  } as any)

const DashboardPaidMediaLayoutChatRoute =
  DashboardPaidMediaLayoutChatImport.update({
    id: '/chat',
    path: '/chat',
    getParentRoute: () => DashboardPaidMediaLayoutRoute,
  } as any)

const DashboardIntelligenceLayoutOverviewRoute =
  DashboardIntelligenceLayoutOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardIntelligenceLayoutRoute,
  } as any)

const DashboardIntelligenceLayoutIndustryRoute =
  DashboardIntelligenceLayoutIndustryImport.update({
    id: '/industry',
    path: '/industry',
    getParentRoute: () => DashboardIntelligenceLayoutRoute,
  } as any)

const DashboardIntelligenceLayoutCreativeAuditRoute =
  DashboardIntelligenceLayoutCreativeAuditImport.update({
    id: '/creative-audit',
    path: '/creative-audit',
    getParentRoute: () => DashboardIntelligenceLayoutRoute,
  } as any)

const DashboardIntelligenceLayoutCompetitiveRoute =
  DashboardIntelligenceLayoutCompetitiveImport.update({
    id: '/competitive',
    path: '/competitive',
    getParentRoute: () => DashboardIntelligenceLayoutRoute,
  } as any)

const DashboardIntelligenceLayoutBrandAuditRoute =
  DashboardIntelligenceLayoutBrandAuditImport.update({
    id: '/brand-audit',
    path: '/brand-audit',
    getParentRoute: () => DashboardIntelligenceLayoutRoute,
  } as any)

const DashboardIntelligenceLayoutAudienceRoute =
  DashboardIntelligenceLayoutAudienceImport.update({
    id: '/audience',
    path: '/audience',
    getParentRoute: () => DashboardIntelligenceLayoutRoute,
  } as any)

const DashboardGovernanceLayoutPerformanceBenchmarkRoute =
  DashboardGovernanceLayoutPerformanceBenchmarkImport.update({
    id: '/performance-benchmark',
    path: '/performance-benchmark',
    getParentRoute: () => DashboardGovernanceLayoutRoute,
  } as any)

const DashboardGovernanceLayoutOverviewRoute =
  DashboardGovernanceLayoutOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardGovernanceLayoutRoute,
  } as any)

const DashboardGovernanceLayoutCreativeMonitorRoute =
  DashboardGovernanceLayoutCreativeMonitorImport.update({
    id: '/creative-monitor',
    path: '/creative-monitor',
    getParentRoute: () => DashboardGovernanceLayoutRoute,
  } as any)

const DashboardGovernanceLayoutComplianceTrackerRoute =
  DashboardGovernanceLayoutComplianceTrackerImport.update({
    id: '/compliance-tracker',
    path: '/compliance-tracker',
    getParentRoute: () => DashboardGovernanceLayoutRoute,
  } as any)

const DashboardConsumerResearchLayoutSubBrandsRoute =
  DashboardConsumerResearchLayoutSubBrandsImport.update({
    id: '/sub-brands',
    path: '/sub-brands',
    getParentRoute: () => DashboardConsumerResearchLayoutRoute,
  } as any)

const DashboardConsumerResearchLayoutSocialFeedRoute =
  DashboardConsumerResearchLayoutSocialFeedImport.update({
    id: '/social-feed',
    path: '/social-feed',
    getParentRoute: () => DashboardConsumerResearchLayoutRoute,
  } as any)

const DashboardConsumerResearchLayoutRulesRoute =
  DashboardConsumerResearchLayoutRulesImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => DashboardConsumerResearchLayoutRoute,
  } as any)

const DashboardConsumerResearchLayoutOverviewRoute =
  DashboardConsumerResearchLayoutOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardConsumerResearchLayoutRoute,
  } as any)

const DashboardConsumerResearchLayoutChannelsRoute =
  DashboardConsumerResearchLayoutChannelsImport.update({
    id: '/channels',
    path: '/channels',
    getParentRoute: () => DashboardConsumerResearchLayoutRoute,
  } as any)

const DashboardConsumerResearchLayoutBrandModeratorRoute =
  DashboardConsumerResearchLayoutBrandModeratorImport.update({
    id: '/brand-moderator',
    path: '/brand-moderator',
    getParentRoute: () => DashboardConsumerResearchLayoutRoute,
  } as any)

const DashboardConsumerResearchLayoutAiResearcherRoute =
  DashboardConsumerResearchLayoutAiResearcherImport.update({
    id: '/ai-researcher',
    path: '/ai-researcher',
    getParentRoute: () => DashboardConsumerResearchLayoutRoute,
  } as any)

const DashboardAiDesignerLayoutLibraryRoute =
  DashboardAiDesignerLayoutLibraryImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => DashboardAiDesignerLayoutRoute,
  } as any)

const DashboardAiDesignerLayoutCreateRoute =
  DashboardAiDesignerLayoutCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => DashboardAiDesignerLayoutRoute,
  } as any)

const DashboardAiDesignerLayoutAppsRoute =
  DashboardAiDesignerLayoutAppsImport.update({
    id: '/apps',
    path: '/apps',
    getParentRoute: () => DashboardAiDesignerLayoutRoute,
  } as any)

const AuthLayoutCallbackMagicLinkRoute =
  AuthLayoutCallbackMagicLinkImport.update({
    id: '/callback/magic-link',
    path: '/callback/magic-link',
    getParentRoute: () => AuthLayoutRoute,
  } as any)

const AuthLayoutCallbackGoogleRoute = AuthLayoutCallbackGoogleImport.update({
  id: '/callback/google',
  path: '/callback/google',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const DashboardConsumerResearchLayoutRulesIndexRoute =
  DashboardConsumerResearchLayoutRulesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardConsumerResearchLayoutRulesRoute,
  } as any)

const DashboardConsumerResearchLayoutRulesCreateRoute =
  DashboardConsumerResearchLayoutRulesCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => DashboardConsumerResearchLayoutRulesRoute,
  } as any)

const DashboardConsumerResearchLayoutRulesUpdateIdRoute =
  DashboardConsumerResearchLayoutRulesUpdateIdImport.update({
    id: '/update/$id',
    path: '/update/$id',
    getParentRoute: () => DashboardConsumerResearchLayoutRulesRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingImport
      parentRoute: typeof rootRoute
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/auth/_layout': {
      id: '/auth/_layout'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthLayoutImport
      parentRoute: typeof AuthRoute
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/_layout': {
      id: '/dashboard/_layout'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardLayoutImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboards/$dashboardId': {
      id: '/dashboards/$dashboardId'
      path: '/dashboards/$dashboardId'
      fullPath: '/dashboards/$dashboardId'
      preLoaderRoute: typeof DashboardsDashboardIdImport
      parentRoute: typeof rootRoute
    }
    '/external/auth': {
      id: '/external/auth'
      path: '/external/auth'
      fullPath: '/external/auth'
      preLoaderRoute: typeof ExternalAuthImport
      parentRoute: typeof rootRoute
    }
    '/oauth': {
      id: '/oauth'
      path: '/oauth'
      fullPath: '/oauth'
      preLoaderRoute: typeof OauthImport
      parentRoute: typeof rootRoute
    }
    '/oauth/_layout': {
      id: '/oauth/_layout'
      path: '/oauth'
      fullPath: '/oauth'
      preLoaderRoute: typeof OauthLayoutImport
      parentRoute: typeof OauthRoute
    }
    '/chat/p/$session': {
      id: '/chat/p/$session'
      path: '/chat/p/$session'
      fullPath: '/chat/p/$session'
      preLoaderRoute: typeof ChatPSessionImport
      parentRoute: typeof rootRoute
    }
    '/chat/r/$session': {
      id: '/chat/r/$session'
      path: '/chat/r/$session'
      fullPath: '/chat/r/$session'
      preLoaderRoute: typeof ChatRSessionImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/_layout/brand': {
      id: '/dashboard/_layout/brand'
      path: '/brand'
      fullPath: '/dashboard/brand'
      preLoaderRoute: typeof DashboardLayoutBrandImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/chats': {
      id: '/dashboard/_layout/chats'
      path: '/chats'
      fullPath: '/dashboard/chats'
      preLoaderRoute: typeof DashboardLayoutChatsImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/community': {
      id: '/dashboard/_layout/community'
      path: '/community'
      fullPath: '/dashboard/community'
      preLoaderRoute: typeof DashboardLayoutCommunityImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/library': {
      id: '/dashboard/_layout/library'
      path: '/library'
      fullPath: '/dashboard/library'
      preLoaderRoute: typeof DashboardLayoutLibraryImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/market-tracker': {
      id: '/dashboard/_layout/market-tracker'
      path: '/market-tracker'
      fullPath: '/dashboard/market-tracker'
      preLoaderRoute: typeof DashboardLayoutMarketTrackerImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/products': {
      id: '/dashboard/_layout/products'
      path: '/products'
      fullPath: '/dashboard/products'
      preLoaderRoute: typeof DashboardLayoutProductsImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/real-time-alerts': {
      id: '/dashboard/_layout/real-time-alerts'
      path: '/real-time-alerts'
      fullPath: '/dashboard/real-time-alerts'
      preLoaderRoute: typeof DashboardLayoutRealTimeAlertsImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/ai-designer': {
      id: '/dashboard/ai-designer'
      path: '/ai-designer'
      fullPath: '/dashboard/ai-designer'
      preLoaderRoute: typeof DashboardAiDesignerImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/ai-designer/_layout': {
      id: '/dashboard/ai-designer/_layout'
      path: '/ai-designer'
      fullPath: '/dashboard/ai-designer'
      preLoaderRoute: typeof DashboardAiDesignerLayoutImport
      parentRoute: typeof DashboardAiDesignerRoute
    }
    '/dashboard/chat/$session': {
      id: '/dashboard/chat/$session'
      path: '/chat/$session'
      fullPath: '/dashboard/chat/$session'
      preLoaderRoute: typeof DashboardChatSessionImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/consumer-research': {
      id: '/dashboard/consumer-research'
      path: '/consumer-research'
      fullPath: '/dashboard/consumer-research'
      preLoaderRoute: typeof DashboardConsumerResearchImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/consumer-research/_layout': {
      id: '/dashboard/consumer-research/_layout'
      path: '/consumer-research'
      fullPath: '/dashboard/consumer-research'
      preLoaderRoute: typeof DashboardConsumerResearchLayoutImport
      parentRoute: typeof DashboardConsumerResearchRoute
    }
    '/dashboard/governance': {
      id: '/dashboard/governance'
      path: '/governance'
      fullPath: '/dashboard/governance'
      preLoaderRoute: typeof DashboardGovernanceImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/governance/_layout': {
      id: '/dashboard/governance/_layout'
      path: '/governance'
      fullPath: '/dashboard/governance'
      preLoaderRoute: typeof DashboardGovernanceLayoutImport
      parentRoute: typeof DashboardGovernanceRoute
    }
    '/dashboard/intelligence': {
      id: '/dashboard/intelligence'
      path: '/intelligence'
      fullPath: '/dashboard/intelligence'
      preLoaderRoute: typeof DashboardIntelligenceImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/intelligence/_layout': {
      id: '/dashboard/intelligence/_layout'
      path: '/intelligence'
      fullPath: '/dashboard/intelligence'
      preLoaderRoute: typeof DashboardIntelligenceLayoutImport
      parentRoute: typeof DashboardIntelligenceRoute
    }
    '/dashboard/paid-media': {
      id: '/dashboard/paid-media'
      path: '/paid-media'
      fullPath: '/dashboard/paid-media'
      preLoaderRoute: typeof DashboardPaidMediaImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/paid-media/_layout': {
      id: '/dashboard/paid-media/_layout'
      path: '/paid-media'
      fullPath: '/dashboard/paid-media'
      preLoaderRoute: typeof DashboardPaidMediaLayoutImport
      parentRoute: typeof DashboardPaidMediaRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/settings/_layout': {
      id: '/dashboard/settings/_layout'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsLayoutImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/dashboards/share/$shareToken': {
      id: '/dashboards/share/$shareToken'
      path: '/dashboards/share/$shareToken'
      fullPath: '/dashboards/share/$shareToken'
      preLoaderRoute: typeof DashboardsShareShareTokenImport
      parentRoute: typeof rootRoute
    }
    '/oauth/_layout/facebook': {
      id: '/oauth/_layout/facebook'
      path: '/facebook'
      fullPath: '/oauth/facebook'
      preLoaderRoute: typeof OauthLayoutFacebookImport
      parentRoute: typeof OauthLayoutImport
    }
    '/oauth/_layout/google': {
      id: '/oauth/_layout/google'
      path: '/google'
      fullPath: '/oauth/google'
      preLoaderRoute: typeof OauthLayoutGoogleImport
      parentRoute: typeof OauthLayoutImport
    }
    '/auth/_layout/': {
      id: '/auth/_layout/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthLayoutIndexImport
      parentRoute: typeof AuthLayoutImport
    }
    '/dashboard/_layout/': {
      id: '/dashboard/_layout/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardLayoutIndexImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/auth/_layout/callback/google': {
      id: '/auth/_layout/callback/google'
      path: '/callback/google'
      fullPath: '/auth/callback/google'
      preLoaderRoute: typeof AuthLayoutCallbackGoogleImport
      parentRoute: typeof AuthLayoutImport
    }
    '/auth/_layout/callback/magic-link': {
      id: '/auth/_layout/callback/magic-link'
      path: '/callback/magic-link'
      fullPath: '/auth/callback/magic-link'
      preLoaderRoute: typeof AuthLayoutCallbackMagicLinkImport
      parentRoute: typeof AuthLayoutImport
    }
    '/dashboard/ai-designer/_layout/apps': {
      id: '/dashboard/ai-designer/_layout/apps'
      path: '/apps'
      fullPath: '/dashboard/ai-designer/apps'
      preLoaderRoute: typeof DashboardAiDesignerLayoutAppsImport
      parentRoute: typeof DashboardAiDesignerLayoutImport
    }
    '/dashboard/ai-designer/_layout/create': {
      id: '/dashboard/ai-designer/_layout/create'
      path: '/create'
      fullPath: '/dashboard/ai-designer/create'
      preLoaderRoute: typeof DashboardAiDesignerLayoutCreateImport
      parentRoute: typeof DashboardAiDesignerLayoutImport
    }
    '/dashboard/ai-designer/_layout/library': {
      id: '/dashboard/ai-designer/_layout/library'
      path: '/library'
      fullPath: '/dashboard/ai-designer/library'
      preLoaderRoute: typeof DashboardAiDesignerLayoutLibraryImport
      parentRoute: typeof DashboardAiDesignerLayoutImport
    }
    '/dashboard/consumer-research/_layout/ai-researcher': {
      id: '/dashboard/consumer-research/_layout/ai-researcher'
      path: '/ai-researcher'
      fullPath: '/dashboard/consumer-research/ai-researcher'
      preLoaderRoute: typeof DashboardConsumerResearchLayoutAiResearcherImport
      parentRoute: typeof DashboardConsumerResearchLayoutImport
    }
    '/dashboard/consumer-research/_layout/brand-moderator': {
      id: '/dashboard/consumer-research/_layout/brand-moderator'
      path: '/brand-moderator'
      fullPath: '/dashboard/consumer-research/brand-moderator'
      preLoaderRoute: typeof DashboardConsumerResearchLayoutBrandModeratorImport
      parentRoute: typeof DashboardConsumerResearchLayoutImport
    }
    '/dashboard/consumer-research/_layout/channels': {
      id: '/dashboard/consumer-research/_layout/channels'
      path: '/channels'
      fullPath: '/dashboard/consumer-research/channels'
      preLoaderRoute: typeof DashboardConsumerResearchLayoutChannelsImport
      parentRoute: typeof DashboardConsumerResearchLayoutImport
    }
    '/dashboard/consumer-research/_layout/overview': {
      id: '/dashboard/consumer-research/_layout/overview'
      path: '/overview'
      fullPath: '/dashboard/consumer-research/overview'
      preLoaderRoute: typeof DashboardConsumerResearchLayoutOverviewImport
      parentRoute: typeof DashboardConsumerResearchLayoutImport
    }
    '/dashboard/consumer-research/_layout/rules': {
      id: '/dashboard/consumer-research/_layout/rules'
      path: '/rules'
      fullPath: '/dashboard/consumer-research/rules'
      preLoaderRoute: typeof DashboardConsumerResearchLayoutRulesImport
      parentRoute: typeof DashboardConsumerResearchLayoutImport
    }
    '/dashboard/consumer-research/_layout/social-feed': {
      id: '/dashboard/consumer-research/_layout/social-feed'
      path: '/social-feed'
      fullPath: '/dashboard/consumer-research/social-feed'
      preLoaderRoute: typeof DashboardConsumerResearchLayoutSocialFeedImport
      parentRoute: typeof DashboardConsumerResearchLayoutImport
    }
    '/dashboard/consumer-research/_layout/sub-brands': {
      id: '/dashboard/consumer-research/_layout/sub-brands'
      path: '/sub-brands'
      fullPath: '/dashboard/consumer-research/sub-brands'
      preLoaderRoute: typeof DashboardConsumerResearchLayoutSubBrandsImport
      parentRoute: typeof DashboardConsumerResearchLayoutImport
    }
    '/dashboard/governance/_layout/compliance-tracker': {
      id: '/dashboard/governance/_layout/compliance-tracker'
      path: '/compliance-tracker'
      fullPath: '/dashboard/governance/compliance-tracker'
      preLoaderRoute: typeof DashboardGovernanceLayoutComplianceTrackerImport
      parentRoute: typeof DashboardGovernanceLayoutImport
    }
    '/dashboard/governance/_layout/creative-monitor': {
      id: '/dashboard/governance/_layout/creative-monitor'
      path: '/creative-monitor'
      fullPath: '/dashboard/governance/creative-monitor'
      preLoaderRoute: typeof DashboardGovernanceLayoutCreativeMonitorImport
      parentRoute: typeof DashboardGovernanceLayoutImport
    }
    '/dashboard/governance/_layout/overview': {
      id: '/dashboard/governance/_layout/overview'
      path: '/overview'
      fullPath: '/dashboard/governance/overview'
      preLoaderRoute: typeof DashboardGovernanceLayoutOverviewImport
      parentRoute: typeof DashboardGovernanceLayoutImport
    }
    '/dashboard/governance/_layout/performance-benchmark': {
      id: '/dashboard/governance/_layout/performance-benchmark'
      path: '/performance-benchmark'
      fullPath: '/dashboard/governance/performance-benchmark'
      preLoaderRoute: typeof DashboardGovernanceLayoutPerformanceBenchmarkImport
      parentRoute: typeof DashboardGovernanceLayoutImport
    }
    '/dashboard/intelligence/_layout/audience': {
      id: '/dashboard/intelligence/_layout/audience'
      path: '/audience'
      fullPath: '/dashboard/intelligence/audience'
      preLoaderRoute: typeof DashboardIntelligenceLayoutAudienceImport
      parentRoute: typeof DashboardIntelligenceLayoutImport
    }
    '/dashboard/intelligence/_layout/brand-audit': {
      id: '/dashboard/intelligence/_layout/brand-audit'
      path: '/brand-audit'
      fullPath: '/dashboard/intelligence/brand-audit'
      preLoaderRoute: typeof DashboardIntelligenceLayoutBrandAuditImport
      parentRoute: typeof DashboardIntelligenceLayoutImport
    }
    '/dashboard/intelligence/_layout/competitive': {
      id: '/dashboard/intelligence/_layout/competitive'
      path: '/competitive'
      fullPath: '/dashboard/intelligence/competitive'
      preLoaderRoute: typeof DashboardIntelligenceLayoutCompetitiveImport
      parentRoute: typeof DashboardIntelligenceLayoutImport
    }
    '/dashboard/intelligence/_layout/creative-audit': {
      id: '/dashboard/intelligence/_layout/creative-audit'
      path: '/creative-audit'
      fullPath: '/dashboard/intelligence/creative-audit'
      preLoaderRoute: typeof DashboardIntelligenceLayoutCreativeAuditImport
      parentRoute: typeof DashboardIntelligenceLayoutImport
    }
    '/dashboard/intelligence/_layout/industry': {
      id: '/dashboard/intelligence/_layout/industry'
      path: '/industry'
      fullPath: '/dashboard/intelligence/industry'
      preLoaderRoute: typeof DashboardIntelligenceLayoutIndustryImport
      parentRoute: typeof DashboardIntelligenceLayoutImport
    }
    '/dashboard/intelligence/_layout/overview': {
      id: '/dashboard/intelligence/_layout/overview'
      path: '/overview'
      fullPath: '/dashboard/intelligence/overview'
      preLoaderRoute: typeof DashboardIntelligenceLayoutOverviewImport
      parentRoute: typeof DashboardIntelligenceLayoutImport
    }
    '/dashboard/paid-media/_layout/chat': {
      id: '/dashboard/paid-media/_layout/chat'
      path: '/chat'
      fullPath: '/dashboard/paid-media/chat'
      preLoaderRoute: typeof DashboardPaidMediaLayoutChatImport
      parentRoute: typeof DashboardPaidMediaLayoutImport
    }
    '/dashboard/paid-media/_layout/connectors': {
      id: '/dashboard/paid-media/_layout/connectors'
      path: '/connectors'
      fullPath: '/dashboard/paid-media/connectors'
      preLoaderRoute: typeof DashboardPaidMediaLayoutConnectorsImport
      parentRoute: typeof DashboardPaidMediaLayoutImport
    }
    '/dashboard/paid-media/_layout/dashboards': {
      id: '/dashboard/paid-media/_layout/dashboards'
      path: '/dashboards'
      fullPath: '/dashboard/paid-media/dashboards'
      preLoaderRoute: typeof DashboardPaidMediaLayoutDashboardsImport
      parentRoute: typeof DashboardPaidMediaLayoutImport
    }
    '/dashboard/paid-media/_layout/overview': {
      id: '/dashboard/paid-media/_layout/overview'
      path: '/overview'
      fullPath: '/dashboard/paid-media/overview'
      preLoaderRoute: typeof DashboardPaidMediaLayoutOverviewImport
      parentRoute: typeof DashboardPaidMediaLayoutImport
    }
    '/dashboard/paid-media/_layout/overview-v3': {
      id: '/dashboard/paid-media/_layout/overview-v3'
      path: '/overview-v3'
      fullPath: '/dashboard/paid-media/overview-v3'
      preLoaderRoute: typeof DashboardPaidMediaLayoutOverviewV3Import
      parentRoute: typeof DashboardPaidMediaLayoutImport
    }
    '/dashboard/paid-media/_layout/playbook': {
      id: '/dashboard/paid-media/_layout/playbook'
      path: '/playbook'
      fullPath: '/dashboard/paid-media/playbook'
      preLoaderRoute: typeof DashboardPaidMediaLayoutPlaybookImport
      parentRoute: typeof DashboardPaidMediaLayoutImport
    }
    '/dashboard/paid-media/_layout/reports': {
      id: '/dashboard/paid-media/_layout/reports'
      path: '/reports'
      fullPath: '/dashboard/paid-media/reports'
      preLoaderRoute: typeof DashboardPaidMediaLayoutReportsImport
      parentRoute: typeof DashboardPaidMediaLayoutImport
    }
    '/dashboard/paid-media/_layout/schedules': {
      id: '/dashboard/paid-media/_layout/schedules'
      path: '/schedules'
      fullPath: '/dashboard/paid-media/schedules'
      preLoaderRoute: typeof DashboardPaidMediaLayoutSchedulesImport
      parentRoute: typeof DashboardPaidMediaLayoutImport
    }
    '/dashboard/settings/_layout/invoices': {
      id: '/dashboard/settings/_layout/invoices'
      path: '/invoices'
      fullPath: '/dashboard/settings/invoices'
      preLoaderRoute: typeof DashboardSettingsLayoutInvoicesImport
      parentRoute: typeof DashboardSettingsLayoutImport
    }
    '/dashboard/settings/_layout/profile': {
      id: '/dashboard/settings/_layout/profile'
      path: '/profile'
      fullPath: '/dashboard/settings/profile'
      preLoaderRoute: typeof DashboardSettingsLayoutProfileImport
      parentRoute: typeof DashboardSettingsLayoutImport
    }
    '/dashboard/settings/_layout/subscription': {
      id: '/dashboard/settings/_layout/subscription'
      path: '/subscription'
      fullPath: '/dashboard/settings/subscription'
      preLoaderRoute: typeof DashboardSettingsLayoutSubscriptionImport
      parentRoute: typeof DashboardSettingsLayoutImport
    }
    '/dashboard/settings/_layout/usage': {
      id: '/dashboard/settings/_layout/usage'
      path: '/usage'
      fullPath: '/dashboard/settings/usage'
      preLoaderRoute: typeof DashboardSettingsLayoutUsageImport
      parentRoute: typeof DashboardSettingsLayoutImport
    }
    '/dashboard/consumer-research/_layout/rules/create': {
      id: '/dashboard/consumer-research/_layout/rules/create'
      path: '/create'
      fullPath: '/dashboard/consumer-research/rules/create'
      preLoaderRoute: typeof DashboardConsumerResearchLayoutRulesCreateImport
      parentRoute: typeof DashboardConsumerResearchLayoutRulesImport
    }
    '/dashboard/consumer-research/_layout/rules/': {
      id: '/dashboard/consumer-research/_layout/rules/'
      path: '/'
      fullPath: '/dashboard/consumer-research/rules/'
      preLoaderRoute: typeof DashboardConsumerResearchLayoutRulesIndexImport
      parentRoute: typeof DashboardConsumerResearchLayoutRulesImport
    }
    '/dashboard/consumer-research/_layout/rules/update/$id': {
      id: '/dashboard/consumer-research/_layout/rules/update/$id'
      path: '/update/$id'
      fullPath: '/dashboard/consumer-research/rules/update/$id'
      preLoaderRoute: typeof DashboardConsumerResearchLayoutRulesUpdateIdImport
      parentRoute: typeof DashboardConsumerResearchLayoutRulesImport
    }
  }
}

// Create and export the route tree

interface AuthLayoutRouteChildren {
  AuthLayoutIndexRoute: typeof AuthLayoutIndexRoute
  AuthLayoutCallbackGoogleRoute: typeof AuthLayoutCallbackGoogleRoute
  AuthLayoutCallbackMagicLinkRoute: typeof AuthLayoutCallbackMagicLinkRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutIndexRoute: AuthLayoutIndexRoute,
  AuthLayoutCallbackGoogleRoute: AuthLayoutCallbackGoogleRoute,
  AuthLayoutCallbackMagicLinkRoute: AuthLayoutCallbackMagicLinkRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DashboardLayoutRouteChildren {
  DashboardLayoutBrandRoute: typeof DashboardLayoutBrandRoute
  DashboardLayoutChatsRoute: typeof DashboardLayoutChatsRoute
  DashboardLayoutCommunityRoute: typeof DashboardLayoutCommunityRoute
  DashboardLayoutLibraryRoute: typeof DashboardLayoutLibraryRoute
  DashboardLayoutMarketTrackerRoute: typeof DashboardLayoutMarketTrackerRoute
  DashboardLayoutProductsRoute: typeof DashboardLayoutProductsRoute
  DashboardLayoutRealTimeAlertsRoute: typeof DashboardLayoutRealTimeAlertsRoute
  DashboardLayoutIndexRoute: typeof DashboardLayoutIndexRoute
}

const DashboardLayoutRouteChildren: DashboardLayoutRouteChildren = {
  DashboardLayoutBrandRoute: DashboardLayoutBrandRoute,
  DashboardLayoutChatsRoute: DashboardLayoutChatsRoute,
  DashboardLayoutCommunityRoute: DashboardLayoutCommunityRoute,
  DashboardLayoutLibraryRoute: DashboardLayoutLibraryRoute,
  DashboardLayoutMarketTrackerRoute: DashboardLayoutMarketTrackerRoute,
  DashboardLayoutProductsRoute: DashboardLayoutProductsRoute,
  DashboardLayoutRealTimeAlertsRoute: DashboardLayoutRealTimeAlertsRoute,
  DashboardLayoutIndexRoute: DashboardLayoutIndexRoute,
}

const DashboardLayoutRouteWithChildren = DashboardLayoutRoute._addFileChildren(
  DashboardLayoutRouteChildren,
)

interface DashboardAiDesignerLayoutRouteChildren {
  DashboardAiDesignerLayoutAppsRoute: typeof DashboardAiDesignerLayoutAppsRoute
  DashboardAiDesignerLayoutCreateRoute: typeof DashboardAiDesignerLayoutCreateRoute
  DashboardAiDesignerLayoutLibraryRoute: typeof DashboardAiDesignerLayoutLibraryRoute
}

const DashboardAiDesignerLayoutRouteChildren: DashboardAiDesignerLayoutRouteChildren =
  {
    DashboardAiDesignerLayoutAppsRoute: DashboardAiDesignerLayoutAppsRoute,
    DashboardAiDesignerLayoutCreateRoute: DashboardAiDesignerLayoutCreateRoute,
    DashboardAiDesignerLayoutLibraryRoute:
      DashboardAiDesignerLayoutLibraryRoute,
  }

const DashboardAiDesignerLayoutRouteWithChildren =
  DashboardAiDesignerLayoutRoute._addFileChildren(
    DashboardAiDesignerLayoutRouteChildren,
  )

interface DashboardAiDesignerRouteChildren {
  DashboardAiDesignerLayoutRoute: typeof DashboardAiDesignerLayoutRouteWithChildren
}

const DashboardAiDesignerRouteChildren: DashboardAiDesignerRouteChildren = {
  DashboardAiDesignerLayoutRoute: DashboardAiDesignerLayoutRouteWithChildren,
}

const DashboardAiDesignerRouteWithChildren =
  DashboardAiDesignerRoute._addFileChildren(DashboardAiDesignerRouteChildren)

interface DashboardConsumerResearchLayoutRulesRouteChildren {
  DashboardConsumerResearchLayoutRulesCreateRoute: typeof DashboardConsumerResearchLayoutRulesCreateRoute
  DashboardConsumerResearchLayoutRulesIndexRoute: typeof DashboardConsumerResearchLayoutRulesIndexRoute
  DashboardConsumerResearchLayoutRulesUpdateIdRoute: typeof DashboardConsumerResearchLayoutRulesUpdateIdRoute
}

const DashboardConsumerResearchLayoutRulesRouteChildren: DashboardConsumerResearchLayoutRulesRouteChildren =
  {
    DashboardConsumerResearchLayoutRulesCreateRoute:
      DashboardConsumerResearchLayoutRulesCreateRoute,
    DashboardConsumerResearchLayoutRulesIndexRoute:
      DashboardConsumerResearchLayoutRulesIndexRoute,
    DashboardConsumerResearchLayoutRulesUpdateIdRoute:
      DashboardConsumerResearchLayoutRulesUpdateIdRoute,
  }

const DashboardConsumerResearchLayoutRulesRouteWithChildren =
  DashboardConsumerResearchLayoutRulesRoute._addFileChildren(
    DashboardConsumerResearchLayoutRulesRouteChildren,
  )

interface DashboardConsumerResearchLayoutRouteChildren {
  DashboardConsumerResearchLayoutAiResearcherRoute: typeof DashboardConsumerResearchLayoutAiResearcherRoute
  DashboardConsumerResearchLayoutBrandModeratorRoute: typeof DashboardConsumerResearchLayoutBrandModeratorRoute
  DashboardConsumerResearchLayoutChannelsRoute: typeof DashboardConsumerResearchLayoutChannelsRoute
  DashboardConsumerResearchLayoutOverviewRoute: typeof DashboardConsumerResearchLayoutOverviewRoute
  DashboardConsumerResearchLayoutRulesRoute: typeof DashboardConsumerResearchLayoutRulesRouteWithChildren
  DashboardConsumerResearchLayoutSocialFeedRoute: typeof DashboardConsumerResearchLayoutSocialFeedRoute
  DashboardConsumerResearchLayoutSubBrandsRoute: typeof DashboardConsumerResearchLayoutSubBrandsRoute
}

const DashboardConsumerResearchLayoutRouteChildren: DashboardConsumerResearchLayoutRouteChildren =
  {
    DashboardConsumerResearchLayoutAiResearcherRoute:
      DashboardConsumerResearchLayoutAiResearcherRoute,
    DashboardConsumerResearchLayoutBrandModeratorRoute:
      DashboardConsumerResearchLayoutBrandModeratorRoute,
    DashboardConsumerResearchLayoutChannelsRoute:
      DashboardConsumerResearchLayoutChannelsRoute,
    DashboardConsumerResearchLayoutOverviewRoute:
      DashboardConsumerResearchLayoutOverviewRoute,
    DashboardConsumerResearchLayoutRulesRoute:
      DashboardConsumerResearchLayoutRulesRouteWithChildren,
    DashboardConsumerResearchLayoutSocialFeedRoute:
      DashboardConsumerResearchLayoutSocialFeedRoute,
    DashboardConsumerResearchLayoutSubBrandsRoute:
      DashboardConsumerResearchLayoutSubBrandsRoute,
  }

const DashboardConsumerResearchLayoutRouteWithChildren =
  DashboardConsumerResearchLayoutRoute._addFileChildren(
    DashboardConsumerResearchLayoutRouteChildren,
  )

interface DashboardConsumerResearchRouteChildren {
  DashboardConsumerResearchLayoutRoute: typeof DashboardConsumerResearchLayoutRouteWithChildren
}

const DashboardConsumerResearchRouteChildren: DashboardConsumerResearchRouteChildren =
  {
    DashboardConsumerResearchLayoutRoute:
      DashboardConsumerResearchLayoutRouteWithChildren,
  }

const DashboardConsumerResearchRouteWithChildren =
  DashboardConsumerResearchRoute._addFileChildren(
    DashboardConsumerResearchRouteChildren,
  )

interface DashboardGovernanceLayoutRouteChildren {
  DashboardGovernanceLayoutComplianceTrackerRoute: typeof DashboardGovernanceLayoutComplianceTrackerRoute
  DashboardGovernanceLayoutCreativeMonitorRoute: typeof DashboardGovernanceLayoutCreativeMonitorRoute
  DashboardGovernanceLayoutOverviewRoute: typeof DashboardGovernanceLayoutOverviewRoute
  DashboardGovernanceLayoutPerformanceBenchmarkRoute: typeof DashboardGovernanceLayoutPerformanceBenchmarkRoute
}

const DashboardGovernanceLayoutRouteChildren: DashboardGovernanceLayoutRouteChildren =
  {
    DashboardGovernanceLayoutComplianceTrackerRoute:
      DashboardGovernanceLayoutComplianceTrackerRoute,
    DashboardGovernanceLayoutCreativeMonitorRoute:
      DashboardGovernanceLayoutCreativeMonitorRoute,
    DashboardGovernanceLayoutOverviewRoute:
      DashboardGovernanceLayoutOverviewRoute,
    DashboardGovernanceLayoutPerformanceBenchmarkRoute:
      DashboardGovernanceLayoutPerformanceBenchmarkRoute,
  }

const DashboardGovernanceLayoutRouteWithChildren =
  DashboardGovernanceLayoutRoute._addFileChildren(
    DashboardGovernanceLayoutRouteChildren,
  )

interface DashboardGovernanceRouteChildren {
  DashboardGovernanceLayoutRoute: typeof DashboardGovernanceLayoutRouteWithChildren
}

const DashboardGovernanceRouteChildren: DashboardGovernanceRouteChildren = {
  DashboardGovernanceLayoutRoute: DashboardGovernanceLayoutRouteWithChildren,
}

const DashboardGovernanceRouteWithChildren =
  DashboardGovernanceRoute._addFileChildren(DashboardGovernanceRouteChildren)

interface DashboardIntelligenceLayoutRouteChildren {
  DashboardIntelligenceLayoutAudienceRoute: typeof DashboardIntelligenceLayoutAudienceRoute
  DashboardIntelligenceLayoutBrandAuditRoute: typeof DashboardIntelligenceLayoutBrandAuditRoute
  DashboardIntelligenceLayoutCompetitiveRoute: typeof DashboardIntelligenceLayoutCompetitiveRoute
  DashboardIntelligenceLayoutCreativeAuditRoute: typeof DashboardIntelligenceLayoutCreativeAuditRoute
  DashboardIntelligenceLayoutIndustryRoute: typeof DashboardIntelligenceLayoutIndustryRoute
  DashboardIntelligenceLayoutOverviewRoute: typeof DashboardIntelligenceLayoutOverviewRoute
}

const DashboardIntelligenceLayoutRouteChildren: DashboardIntelligenceLayoutRouteChildren =
  {
    DashboardIntelligenceLayoutAudienceRoute:
      DashboardIntelligenceLayoutAudienceRoute,
    DashboardIntelligenceLayoutBrandAuditRoute:
      DashboardIntelligenceLayoutBrandAuditRoute,
    DashboardIntelligenceLayoutCompetitiveRoute:
      DashboardIntelligenceLayoutCompetitiveRoute,
    DashboardIntelligenceLayoutCreativeAuditRoute:
      DashboardIntelligenceLayoutCreativeAuditRoute,
    DashboardIntelligenceLayoutIndustryRoute:
      DashboardIntelligenceLayoutIndustryRoute,
    DashboardIntelligenceLayoutOverviewRoute:
      DashboardIntelligenceLayoutOverviewRoute,
  }

const DashboardIntelligenceLayoutRouteWithChildren =
  DashboardIntelligenceLayoutRoute._addFileChildren(
    DashboardIntelligenceLayoutRouteChildren,
  )

interface DashboardIntelligenceRouteChildren {
  DashboardIntelligenceLayoutRoute: typeof DashboardIntelligenceLayoutRouteWithChildren
}

const DashboardIntelligenceRouteChildren: DashboardIntelligenceRouteChildren = {
  DashboardIntelligenceLayoutRoute:
    DashboardIntelligenceLayoutRouteWithChildren,
}

const DashboardIntelligenceRouteWithChildren =
  DashboardIntelligenceRoute._addFileChildren(
    DashboardIntelligenceRouteChildren,
  )

interface DashboardPaidMediaLayoutRouteChildren {
  DashboardPaidMediaLayoutChatRoute: typeof DashboardPaidMediaLayoutChatRoute
  DashboardPaidMediaLayoutConnectorsRoute: typeof DashboardPaidMediaLayoutConnectorsRoute
  DashboardPaidMediaLayoutDashboardsRoute: typeof DashboardPaidMediaLayoutDashboardsRoute
  DashboardPaidMediaLayoutOverviewRoute: typeof DashboardPaidMediaLayoutOverviewRoute
  DashboardPaidMediaLayoutOverviewV3Route: typeof DashboardPaidMediaLayoutOverviewV3Route
  DashboardPaidMediaLayoutPlaybookRoute: typeof DashboardPaidMediaLayoutPlaybookRoute
  DashboardPaidMediaLayoutReportsRoute: typeof DashboardPaidMediaLayoutReportsRoute
  DashboardPaidMediaLayoutSchedulesRoute: typeof DashboardPaidMediaLayoutSchedulesRoute
}

const DashboardPaidMediaLayoutRouteChildren: DashboardPaidMediaLayoutRouteChildren =
  {
    DashboardPaidMediaLayoutChatRoute: DashboardPaidMediaLayoutChatRoute,
    DashboardPaidMediaLayoutConnectorsRoute:
      DashboardPaidMediaLayoutConnectorsRoute,
    DashboardPaidMediaLayoutDashboardsRoute:
      DashboardPaidMediaLayoutDashboardsRoute,
    DashboardPaidMediaLayoutOverviewRoute:
      DashboardPaidMediaLayoutOverviewRoute,
    DashboardPaidMediaLayoutOverviewV3Route:
      DashboardPaidMediaLayoutOverviewV3Route,
    DashboardPaidMediaLayoutPlaybookRoute:
      DashboardPaidMediaLayoutPlaybookRoute,
    DashboardPaidMediaLayoutReportsRoute: DashboardPaidMediaLayoutReportsRoute,
    DashboardPaidMediaLayoutSchedulesRoute:
      DashboardPaidMediaLayoutSchedulesRoute,
  }

const DashboardPaidMediaLayoutRouteWithChildren =
  DashboardPaidMediaLayoutRoute._addFileChildren(
    DashboardPaidMediaLayoutRouteChildren,
  )

interface DashboardPaidMediaRouteChildren {
  DashboardPaidMediaLayoutRoute: typeof DashboardPaidMediaLayoutRouteWithChildren
}

const DashboardPaidMediaRouteChildren: DashboardPaidMediaRouteChildren = {
  DashboardPaidMediaLayoutRoute: DashboardPaidMediaLayoutRouteWithChildren,
}

const DashboardPaidMediaRouteWithChildren =
  DashboardPaidMediaRoute._addFileChildren(DashboardPaidMediaRouteChildren)

interface DashboardSettingsLayoutRouteChildren {
  DashboardSettingsLayoutInvoicesRoute: typeof DashboardSettingsLayoutInvoicesRoute
  DashboardSettingsLayoutProfileRoute: typeof DashboardSettingsLayoutProfileRoute
  DashboardSettingsLayoutSubscriptionRoute: typeof DashboardSettingsLayoutSubscriptionRoute
  DashboardSettingsLayoutUsageRoute: typeof DashboardSettingsLayoutUsageRoute
}

const DashboardSettingsLayoutRouteChildren: DashboardSettingsLayoutRouteChildren =
  {
    DashboardSettingsLayoutInvoicesRoute: DashboardSettingsLayoutInvoicesRoute,
    DashboardSettingsLayoutProfileRoute: DashboardSettingsLayoutProfileRoute,
    DashboardSettingsLayoutSubscriptionRoute:
      DashboardSettingsLayoutSubscriptionRoute,
    DashboardSettingsLayoutUsageRoute: DashboardSettingsLayoutUsageRoute,
  }

const DashboardSettingsLayoutRouteWithChildren =
  DashboardSettingsLayoutRoute._addFileChildren(
    DashboardSettingsLayoutRouteChildren,
  )

interface DashboardSettingsRouteChildren {
  DashboardSettingsLayoutRoute: typeof DashboardSettingsLayoutRouteWithChildren
}

const DashboardSettingsRouteChildren: DashboardSettingsRouteChildren = {
  DashboardSettingsLayoutRoute: DashboardSettingsLayoutRouteWithChildren,
}

const DashboardSettingsRouteWithChildren =
  DashboardSettingsRoute._addFileChildren(DashboardSettingsRouteChildren)

interface DashboardRouteChildren {
  DashboardLayoutRoute: typeof DashboardLayoutRouteWithChildren
  DashboardAiDesignerRoute: typeof DashboardAiDesignerRouteWithChildren
  DashboardChatSessionRoute: typeof DashboardChatSessionRoute
  DashboardConsumerResearchRoute: typeof DashboardConsumerResearchRouteWithChildren
  DashboardGovernanceRoute: typeof DashboardGovernanceRouteWithChildren
  DashboardIntelligenceRoute: typeof DashboardIntelligenceRouteWithChildren
  DashboardPaidMediaRoute: typeof DashboardPaidMediaRouteWithChildren
  DashboardSettingsRoute: typeof DashboardSettingsRouteWithChildren
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardLayoutRoute: DashboardLayoutRouteWithChildren,
  DashboardAiDesignerRoute: DashboardAiDesignerRouteWithChildren,
  DashboardChatSessionRoute: DashboardChatSessionRoute,
  DashboardConsumerResearchRoute: DashboardConsumerResearchRouteWithChildren,
  DashboardGovernanceRoute: DashboardGovernanceRouteWithChildren,
  DashboardIntelligenceRoute: DashboardIntelligenceRouteWithChildren,
  DashboardPaidMediaRoute: DashboardPaidMediaRouteWithChildren,
  DashboardSettingsRoute: DashboardSettingsRouteWithChildren,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface OauthLayoutRouteChildren {
  OauthLayoutFacebookRoute: typeof OauthLayoutFacebookRoute
  OauthLayoutGoogleRoute: typeof OauthLayoutGoogleRoute
}

const OauthLayoutRouteChildren: OauthLayoutRouteChildren = {
  OauthLayoutFacebookRoute: OauthLayoutFacebookRoute,
  OauthLayoutGoogleRoute: OauthLayoutGoogleRoute,
}

const OauthLayoutRouteWithChildren = OauthLayoutRoute._addFileChildren(
  OauthLayoutRouteChildren,
)

interface OauthRouteChildren {
  OauthLayoutRoute: typeof OauthLayoutRouteWithChildren
}

const OauthRouteChildren: OauthRouteChildren = {
  OauthLayoutRoute: OauthLayoutRouteWithChildren,
}

const OauthRouteWithChildren = OauthRoute._addFileChildren(OauthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/auth': typeof AuthLayoutRouteWithChildren
  '/dashboard': typeof DashboardLayoutRouteWithChildren
  '/dashboards/$dashboardId': typeof DashboardsDashboardIdRoute
  '/external/auth': typeof ExternalAuthRoute
  '/oauth': typeof OauthLayoutRouteWithChildren
  '/chat/p/$session': typeof ChatPSessionRoute
  '/chat/r/$session': typeof ChatRSessionRoute
  '/dashboard/brand': typeof DashboardLayoutBrandRoute
  '/dashboard/chats': typeof DashboardLayoutChatsRoute
  '/dashboard/community': typeof DashboardLayoutCommunityRoute
  '/dashboard/library': typeof DashboardLayoutLibraryRoute
  '/dashboard/market-tracker': typeof DashboardLayoutMarketTrackerRoute
  '/dashboard/products': typeof DashboardLayoutProductsRoute
  '/dashboard/real-time-alerts': typeof DashboardLayoutRealTimeAlertsRoute
  '/dashboard/ai-designer': typeof DashboardAiDesignerLayoutRouteWithChildren
  '/dashboard/chat/$session': typeof DashboardChatSessionRoute
  '/dashboard/consumer-research': typeof DashboardConsumerResearchLayoutRouteWithChildren
  '/dashboard/governance': typeof DashboardGovernanceLayoutRouteWithChildren
  '/dashboard/intelligence': typeof DashboardIntelligenceLayoutRouteWithChildren
  '/dashboard/paid-media': typeof DashboardPaidMediaLayoutRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsLayoutRouteWithChildren
  '/dashboards/share/$shareToken': typeof DashboardsShareShareTokenRoute
  '/oauth/facebook': typeof OauthLayoutFacebookRoute
  '/oauth/google': typeof OauthLayoutGoogleRoute
  '/auth/': typeof AuthLayoutIndexRoute
  '/dashboard/': typeof DashboardLayoutIndexRoute
  '/auth/callback/google': typeof AuthLayoutCallbackGoogleRoute
  '/auth/callback/magic-link': typeof AuthLayoutCallbackMagicLinkRoute
  '/dashboard/ai-designer/apps': typeof DashboardAiDesignerLayoutAppsRoute
  '/dashboard/ai-designer/create': typeof DashboardAiDesignerLayoutCreateRoute
  '/dashboard/ai-designer/library': typeof DashboardAiDesignerLayoutLibraryRoute
  '/dashboard/consumer-research/ai-researcher': typeof DashboardConsumerResearchLayoutAiResearcherRoute
  '/dashboard/consumer-research/brand-moderator': typeof DashboardConsumerResearchLayoutBrandModeratorRoute
  '/dashboard/consumer-research/channels': typeof DashboardConsumerResearchLayoutChannelsRoute
  '/dashboard/consumer-research/overview': typeof DashboardConsumerResearchLayoutOverviewRoute
  '/dashboard/consumer-research/rules': typeof DashboardConsumerResearchLayoutRulesRouteWithChildren
  '/dashboard/consumer-research/social-feed': typeof DashboardConsumerResearchLayoutSocialFeedRoute
  '/dashboard/consumer-research/sub-brands': typeof DashboardConsumerResearchLayoutSubBrandsRoute
  '/dashboard/governance/compliance-tracker': typeof DashboardGovernanceLayoutComplianceTrackerRoute
  '/dashboard/governance/creative-monitor': typeof DashboardGovernanceLayoutCreativeMonitorRoute
  '/dashboard/governance/overview': typeof DashboardGovernanceLayoutOverviewRoute
  '/dashboard/governance/performance-benchmark': typeof DashboardGovernanceLayoutPerformanceBenchmarkRoute
  '/dashboard/intelligence/audience': typeof DashboardIntelligenceLayoutAudienceRoute
  '/dashboard/intelligence/brand-audit': typeof DashboardIntelligenceLayoutBrandAuditRoute
  '/dashboard/intelligence/competitive': typeof DashboardIntelligenceLayoutCompetitiveRoute
  '/dashboard/intelligence/creative-audit': typeof DashboardIntelligenceLayoutCreativeAuditRoute
  '/dashboard/intelligence/industry': typeof DashboardIntelligenceLayoutIndustryRoute
  '/dashboard/intelligence/overview': typeof DashboardIntelligenceLayoutOverviewRoute
  '/dashboard/paid-media/chat': typeof DashboardPaidMediaLayoutChatRoute
  '/dashboard/paid-media/connectors': typeof DashboardPaidMediaLayoutConnectorsRoute
  '/dashboard/paid-media/dashboards': typeof DashboardPaidMediaLayoutDashboardsRoute
  '/dashboard/paid-media/overview': typeof DashboardPaidMediaLayoutOverviewRoute
  '/dashboard/paid-media/overview-v3': typeof DashboardPaidMediaLayoutOverviewV3Route
  '/dashboard/paid-media/playbook': typeof DashboardPaidMediaLayoutPlaybookRoute
  '/dashboard/paid-media/reports': typeof DashboardPaidMediaLayoutReportsRoute
  '/dashboard/paid-media/schedules': typeof DashboardPaidMediaLayoutSchedulesRoute
  '/dashboard/settings/invoices': typeof DashboardSettingsLayoutInvoicesRoute
  '/dashboard/settings/profile': typeof DashboardSettingsLayoutProfileRoute
  '/dashboard/settings/subscription': typeof DashboardSettingsLayoutSubscriptionRoute
  '/dashboard/settings/usage': typeof DashboardSettingsLayoutUsageRoute
  '/dashboard/consumer-research/rules/create': typeof DashboardConsumerResearchLayoutRulesCreateRoute
  '/dashboard/consumer-research/rules/': typeof DashboardConsumerResearchLayoutRulesIndexRoute
  '/dashboard/consumer-research/rules/update/$id': typeof DashboardConsumerResearchLayoutRulesUpdateIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/auth': typeof AuthLayoutIndexRoute
  '/dashboard': typeof DashboardLayoutIndexRoute
  '/dashboards/$dashboardId': typeof DashboardsDashboardIdRoute
  '/external/auth': typeof ExternalAuthRoute
  '/oauth': typeof OauthLayoutRouteWithChildren
  '/chat/p/$session': typeof ChatPSessionRoute
  '/chat/r/$session': typeof ChatRSessionRoute
  '/dashboard/brand': typeof DashboardLayoutBrandRoute
  '/dashboard/chats': typeof DashboardLayoutChatsRoute
  '/dashboard/community': typeof DashboardLayoutCommunityRoute
  '/dashboard/library': typeof DashboardLayoutLibraryRoute
  '/dashboard/market-tracker': typeof DashboardLayoutMarketTrackerRoute
  '/dashboard/products': typeof DashboardLayoutProductsRoute
  '/dashboard/real-time-alerts': typeof DashboardLayoutRealTimeAlertsRoute
  '/dashboard/ai-designer': typeof DashboardAiDesignerLayoutRouteWithChildren
  '/dashboard/chat/$session': typeof DashboardChatSessionRoute
  '/dashboard/consumer-research': typeof DashboardConsumerResearchLayoutRouteWithChildren
  '/dashboard/governance': typeof DashboardGovernanceLayoutRouteWithChildren
  '/dashboard/intelligence': typeof DashboardIntelligenceLayoutRouteWithChildren
  '/dashboard/paid-media': typeof DashboardPaidMediaLayoutRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsLayoutRouteWithChildren
  '/dashboards/share/$shareToken': typeof DashboardsShareShareTokenRoute
  '/oauth/facebook': typeof OauthLayoutFacebookRoute
  '/oauth/google': typeof OauthLayoutGoogleRoute
  '/auth/callback/google': typeof AuthLayoutCallbackGoogleRoute
  '/auth/callback/magic-link': typeof AuthLayoutCallbackMagicLinkRoute
  '/dashboard/ai-designer/apps': typeof DashboardAiDesignerLayoutAppsRoute
  '/dashboard/ai-designer/create': typeof DashboardAiDesignerLayoutCreateRoute
  '/dashboard/ai-designer/library': typeof DashboardAiDesignerLayoutLibraryRoute
  '/dashboard/consumer-research/ai-researcher': typeof DashboardConsumerResearchLayoutAiResearcherRoute
  '/dashboard/consumer-research/brand-moderator': typeof DashboardConsumerResearchLayoutBrandModeratorRoute
  '/dashboard/consumer-research/channels': typeof DashboardConsumerResearchLayoutChannelsRoute
  '/dashboard/consumer-research/overview': typeof DashboardConsumerResearchLayoutOverviewRoute
  '/dashboard/consumer-research/social-feed': typeof DashboardConsumerResearchLayoutSocialFeedRoute
  '/dashboard/consumer-research/sub-brands': typeof DashboardConsumerResearchLayoutSubBrandsRoute
  '/dashboard/governance/compliance-tracker': typeof DashboardGovernanceLayoutComplianceTrackerRoute
  '/dashboard/governance/creative-monitor': typeof DashboardGovernanceLayoutCreativeMonitorRoute
  '/dashboard/governance/overview': typeof DashboardGovernanceLayoutOverviewRoute
  '/dashboard/governance/performance-benchmark': typeof DashboardGovernanceLayoutPerformanceBenchmarkRoute
  '/dashboard/intelligence/audience': typeof DashboardIntelligenceLayoutAudienceRoute
  '/dashboard/intelligence/brand-audit': typeof DashboardIntelligenceLayoutBrandAuditRoute
  '/dashboard/intelligence/competitive': typeof DashboardIntelligenceLayoutCompetitiveRoute
  '/dashboard/intelligence/creative-audit': typeof DashboardIntelligenceLayoutCreativeAuditRoute
  '/dashboard/intelligence/industry': typeof DashboardIntelligenceLayoutIndustryRoute
  '/dashboard/intelligence/overview': typeof DashboardIntelligenceLayoutOverviewRoute
  '/dashboard/paid-media/chat': typeof DashboardPaidMediaLayoutChatRoute
  '/dashboard/paid-media/connectors': typeof DashboardPaidMediaLayoutConnectorsRoute
  '/dashboard/paid-media/dashboards': typeof DashboardPaidMediaLayoutDashboardsRoute
  '/dashboard/paid-media/overview': typeof DashboardPaidMediaLayoutOverviewRoute
  '/dashboard/paid-media/overview-v3': typeof DashboardPaidMediaLayoutOverviewV3Route
  '/dashboard/paid-media/playbook': typeof DashboardPaidMediaLayoutPlaybookRoute
  '/dashboard/paid-media/reports': typeof DashboardPaidMediaLayoutReportsRoute
  '/dashboard/paid-media/schedules': typeof DashboardPaidMediaLayoutSchedulesRoute
  '/dashboard/settings/invoices': typeof DashboardSettingsLayoutInvoicesRoute
  '/dashboard/settings/profile': typeof DashboardSettingsLayoutProfileRoute
  '/dashboard/settings/subscription': typeof DashboardSettingsLayoutSubscriptionRoute
  '/dashboard/settings/usage': typeof DashboardSettingsLayoutUsageRoute
  '/dashboard/consumer-research/rules/create': typeof DashboardConsumerResearchLayoutRulesCreateRoute
  '/dashboard/consumer-research/rules': typeof DashboardConsumerResearchLayoutRulesIndexRoute
  '/dashboard/consumer-research/rules/update/$id': typeof DashboardConsumerResearchLayoutRulesUpdateIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/auth': typeof AuthRouteWithChildren
  '/auth/_layout': typeof AuthLayoutRouteWithChildren
  '/dashboard': typeof DashboardRouteWithChildren
  '/dashboard/_layout': typeof DashboardLayoutRouteWithChildren
  '/dashboards/$dashboardId': typeof DashboardsDashboardIdRoute
  '/external/auth': typeof ExternalAuthRoute
  '/oauth': typeof OauthRouteWithChildren
  '/oauth/_layout': typeof OauthLayoutRouteWithChildren
  '/chat/p/$session': typeof ChatPSessionRoute
  '/chat/r/$session': typeof ChatRSessionRoute
  '/dashboard/_layout/brand': typeof DashboardLayoutBrandRoute
  '/dashboard/_layout/chats': typeof DashboardLayoutChatsRoute
  '/dashboard/_layout/community': typeof DashboardLayoutCommunityRoute
  '/dashboard/_layout/library': typeof DashboardLayoutLibraryRoute
  '/dashboard/_layout/market-tracker': typeof DashboardLayoutMarketTrackerRoute
  '/dashboard/_layout/products': typeof DashboardLayoutProductsRoute
  '/dashboard/_layout/real-time-alerts': typeof DashboardLayoutRealTimeAlertsRoute
  '/dashboard/ai-designer': typeof DashboardAiDesignerRouteWithChildren
  '/dashboard/ai-designer/_layout': typeof DashboardAiDesignerLayoutRouteWithChildren
  '/dashboard/chat/$session': typeof DashboardChatSessionRoute
  '/dashboard/consumer-research': typeof DashboardConsumerResearchRouteWithChildren
  '/dashboard/consumer-research/_layout': typeof DashboardConsumerResearchLayoutRouteWithChildren
  '/dashboard/governance': typeof DashboardGovernanceRouteWithChildren
  '/dashboard/governance/_layout': typeof DashboardGovernanceLayoutRouteWithChildren
  '/dashboard/intelligence': typeof DashboardIntelligenceRouteWithChildren
  '/dashboard/intelligence/_layout': typeof DashboardIntelligenceLayoutRouteWithChildren
  '/dashboard/paid-media': typeof DashboardPaidMediaRouteWithChildren
  '/dashboard/paid-media/_layout': typeof DashboardPaidMediaLayoutRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsRouteWithChildren
  '/dashboard/settings/_layout': typeof DashboardSettingsLayoutRouteWithChildren
  '/dashboards/share/$shareToken': typeof DashboardsShareShareTokenRoute
  '/oauth/_layout/facebook': typeof OauthLayoutFacebookRoute
  '/oauth/_layout/google': typeof OauthLayoutGoogleRoute
  '/auth/_layout/': typeof AuthLayoutIndexRoute
  '/dashboard/_layout/': typeof DashboardLayoutIndexRoute
  '/auth/_layout/callback/google': typeof AuthLayoutCallbackGoogleRoute
  '/auth/_layout/callback/magic-link': typeof AuthLayoutCallbackMagicLinkRoute
  '/dashboard/ai-designer/_layout/apps': typeof DashboardAiDesignerLayoutAppsRoute
  '/dashboard/ai-designer/_layout/create': typeof DashboardAiDesignerLayoutCreateRoute
  '/dashboard/ai-designer/_layout/library': typeof DashboardAiDesignerLayoutLibraryRoute
  '/dashboard/consumer-research/_layout/ai-researcher': typeof DashboardConsumerResearchLayoutAiResearcherRoute
  '/dashboard/consumer-research/_layout/brand-moderator': typeof DashboardConsumerResearchLayoutBrandModeratorRoute
  '/dashboard/consumer-research/_layout/channels': typeof DashboardConsumerResearchLayoutChannelsRoute
  '/dashboard/consumer-research/_layout/overview': typeof DashboardConsumerResearchLayoutOverviewRoute
  '/dashboard/consumer-research/_layout/rules': typeof DashboardConsumerResearchLayoutRulesRouteWithChildren
  '/dashboard/consumer-research/_layout/social-feed': typeof DashboardConsumerResearchLayoutSocialFeedRoute
  '/dashboard/consumer-research/_layout/sub-brands': typeof DashboardConsumerResearchLayoutSubBrandsRoute
  '/dashboard/governance/_layout/compliance-tracker': typeof DashboardGovernanceLayoutComplianceTrackerRoute
  '/dashboard/governance/_layout/creative-monitor': typeof DashboardGovernanceLayoutCreativeMonitorRoute
  '/dashboard/governance/_layout/overview': typeof DashboardGovernanceLayoutOverviewRoute
  '/dashboard/governance/_layout/performance-benchmark': typeof DashboardGovernanceLayoutPerformanceBenchmarkRoute
  '/dashboard/intelligence/_layout/audience': typeof DashboardIntelligenceLayoutAudienceRoute
  '/dashboard/intelligence/_layout/brand-audit': typeof DashboardIntelligenceLayoutBrandAuditRoute
  '/dashboard/intelligence/_layout/competitive': typeof DashboardIntelligenceLayoutCompetitiveRoute
  '/dashboard/intelligence/_layout/creative-audit': typeof DashboardIntelligenceLayoutCreativeAuditRoute
  '/dashboard/intelligence/_layout/industry': typeof DashboardIntelligenceLayoutIndustryRoute
  '/dashboard/intelligence/_layout/overview': typeof DashboardIntelligenceLayoutOverviewRoute
  '/dashboard/paid-media/_layout/chat': typeof DashboardPaidMediaLayoutChatRoute
  '/dashboard/paid-media/_layout/connectors': typeof DashboardPaidMediaLayoutConnectorsRoute
  '/dashboard/paid-media/_layout/dashboards': typeof DashboardPaidMediaLayoutDashboardsRoute
  '/dashboard/paid-media/_layout/overview': typeof DashboardPaidMediaLayoutOverviewRoute
  '/dashboard/paid-media/_layout/overview-v3': typeof DashboardPaidMediaLayoutOverviewV3Route
  '/dashboard/paid-media/_layout/playbook': typeof DashboardPaidMediaLayoutPlaybookRoute
  '/dashboard/paid-media/_layout/reports': typeof DashboardPaidMediaLayoutReportsRoute
  '/dashboard/paid-media/_layout/schedules': typeof DashboardPaidMediaLayoutSchedulesRoute
  '/dashboard/settings/_layout/invoices': typeof DashboardSettingsLayoutInvoicesRoute
  '/dashboard/settings/_layout/profile': typeof DashboardSettingsLayoutProfileRoute
  '/dashboard/settings/_layout/subscription': typeof DashboardSettingsLayoutSubscriptionRoute
  '/dashboard/settings/_layout/usage': typeof DashboardSettingsLayoutUsageRoute
  '/dashboard/consumer-research/_layout/rules/create': typeof DashboardConsumerResearchLayoutRulesCreateRoute
  '/dashboard/consumer-research/_layout/rules/': typeof DashboardConsumerResearchLayoutRulesIndexRoute
  '/dashboard/consumer-research/_layout/rules/update/$id': typeof DashboardConsumerResearchLayoutRulesUpdateIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/auth'
    | '/dashboard'
    | '/dashboards/$dashboardId'
    | '/external/auth'
    | '/oauth'
    | '/chat/p/$session'
    | '/chat/r/$session'
    | '/dashboard/brand'
    | '/dashboard/chats'
    | '/dashboard/community'
    | '/dashboard/library'
    | '/dashboard/market-tracker'
    | '/dashboard/products'
    | '/dashboard/real-time-alerts'
    | '/dashboard/ai-designer'
    | '/dashboard/chat/$session'
    | '/dashboard/consumer-research'
    | '/dashboard/governance'
    | '/dashboard/intelligence'
    | '/dashboard/paid-media'
    | '/dashboard/settings'
    | '/dashboards/share/$shareToken'
    | '/oauth/facebook'
    | '/oauth/google'
    | '/auth/'
    | '/dashboard/'
    | '/auth/callback/google'
    | '/auth/callback/magic-link'
    | '/dashboard/ai-designer/apps'
    | '/dashboard/ai-designer/create'
    | '/dashboard/ai-designer/library'
    | '/dashboard/consumer-research/ai-researcher'
    | '/dashboard/consumer-research/brand-moderator'
    | '/dashboard/consumer-research/channels'
    | '/dashboard/consumer-research/overview'
    | '/dashboard/consumer-research/rules'
    | '/dashboard/consumer-research/social-feed'
    | '/dashboard/consumer-research/sub-brands'
    | '/dashboard/governance/compliance-tracker'
    | '/dashboard/governance/creative-monitor'
    | '/dashboard/governance/overview'
    | '/dashboard/governance/performance-benchmark'
    | '/dashboard/intelligence/audience'
    | '/dashboard/intelligence/brand-audit'
    | '/dashboard/intelligence/competitive'
    | '/dashboard/intelligence/creative-audit'
    | '/dashboard/intelligence/industry'
    | '/dashboard/intelligence/overview'
    | '/dashboard/paid-media/chat'
    | '/dashboard/paid-media/connectors'
    | '/dashboard/paid-media/dashboards'
    | '/dashboard/paid-media/overview'
    | '/dashboard/paid-media/overview-v3'
    | '/dashboard/paid-media/playbook'
    | '/dashboard/paid-media/reports'
    | '/dashboard/paid-media/schedules'
    | '/dashboard/settings/invoices'
    | '/dashboard/settings/profile'
    | '/dashboard/settings/subscription'
    | '/dashboard/settings/usage'
    | '/dashboard/consumer-research/rules/create'
    | '/dashboard/consumer-research/rules/'
    | '/dashboard/consumer-research/rules/update/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/auth'
    | '/dashboard'
    | '/dashboards/$dashboardId'
    | '/external/auth'
    | '/oauth'
    | '/chat/p/$session'
    | '/chat/r/$session'
    | '/dashboard/brand'
    | '/dashboard/chats'
    | '/dashboard/community'
    | '/dashboard/library'
    | '/dashboard/market-tracker'
    | '/dashboard/products'
    | '/dashboard/real-time-alerts'
    | '/dashboard/ai-designer'
    | '/dashboard/chat/$session'
    | '/dashboard/consumer-research'
    | '/dashboard/governance'
    | '/dashboard/intelligence'
    | '/dashboard/paid-media'
    | '/dashboard/settings'
    | '/dashboards/share/$shareToken'
    | '/oauth/facebook'
    | '/oauth/google'
    | '/auth/callback/google'
    | '/auth/callback/magic-link'
    | '/dashboard/ai-designer/apps'
    | '/dashboard/ai-designer/create'
    | '/dashboard/ai-designer/library'
    | '/dashboard/consumer-research/ai-researcher'
    | '/dashboard/consumer-research/brand-moderator'
    | '/dashboard/consumer-research/channels'
    | '/dashboard/consumer-research/overview'
    | '/dashboard/consumer-research/social-feed'
    | '/dashboard/consumer-research/sub-brands'
    | '/dashboard/governance/compliance-tracker'
    | '/dashboard/governance/creative-monitor'
    | '/dashboard/governance/overview'
    | '/dashboard/governance/performance-benchmark'
    | '/dashboard/intelligence/audience'
    | '/dashboard/intelligence/brand-audit'
    | '/dashboard/intelligence/competitive'
    | '/dashboard/intelligence/creative-audit'
    | '/dashboard/intelligence/industry'
    | '/dashboard/intelligence/overview'
    | '/dashboard/paid-media/chat'
    | '/dashboard/paid-media/connectors'
    | '/dashboard/paid-media/dashboards'
    | '/dashboard/paid-media/overview'
    | '/dashboard/paid-media/overview-v3'
    | '/dashboard/paid-media/playbook'
    | '/dashboard/paid-media/reports'
    | '/dashboard/paid-media/schedules'
    | '/dashboard/settings/invoices'
    | '/dashboard/settings/profile'
    | '/dashboard/settings/subscription'
    | '/dashboard/settings/usage'
    | '/dashboard/consumer-research/rules/create'
    | '/dashboard/consumer-research/rules'
    | '/dashboard/consumer-research/rules/update/$id'
  id:
    | '__root__'
    | '/'
    | '/onboarding'
    | '/auth'
    | '/auth/_layout'
    | '/dashboard'
    | '/dashboard/_layout'
    | '/dashboards/$dashboardId'
    | '/external/auth'
    | '/oauth'
    | '/oauth/_layout'
    | '/chat/p/$session'
    | '/chat/r/$session'
    | '/dashboard/_layout/brand'
    | '/dashboard/_layout/chats'
    | '/dashboard/_layout/community'
    | '/dashboard/_layout/library'
    | '/dashboard/_layout/market-tracker'
    | '/dashboard/_layout/products'
    | '/dashboard/_layout/real-time-alerts'
    | '/dashboard/ai-designer'
    | '/dashboard/ai-designer/_layout'
    | '/dashboard/chat/$session'
    | '/dashboard/consumer-research'
    | '/dashboard/consumer-research/_layout'
    | '/dashboard/governance'
    | '/dashboard/governance/_layout'
    | '/dashboard/intelligence'
    | '/dashboard/intelligence/_layout'
    | '/dashboard/paid-media'
    | '/dashboard/paid-media/_layout'
    | '/dashboard/settings'
    | '/dashboard/settings/_layout'
    | '/dashboards/share/$shareToken'
    | '/oauth/_layout/facebook'
    | '/oauth/_layout/google'
    | '/auth/_layout/'
    | '/dashboard/_layout/'
    | '/auth/_layout/callback/google'
    | '/auth/_layout/callback/magic-link'
    | '/dashboard/ai-designer/_layout/apps'
    | '/dashboard/ai-designer/_layout/create'
    | '/dashboard/ai-designer/_layout/library'
    | '/dashboard/consumer-research/_layout/ai-researcher'
    | '/dashboard/consumer-research/_layout/brand-moderator'
    | '/dashboard/consumer-research/_layout/channels'
    | '/dashboard/consumer-research/_layout/overview'
    | '/dashboard/consumer-research/_layout/rules'
    | '/dashboard/consumer-research/_layout/social-feed'
    | '/dashboard/consumer-research/_layout/sub-brands'
    | '/dashboard/governance/_layout/compliance-tracker'
    | '/dashboard/governance/_layout/creative-monitor'
    | '/dashboard/governance/_layout/overview'
    | '/dashboard/governance/_layout/performance-benchmark'
    | '/dashboard/intelligence/_layout/audience'
    | '/dashboard/intelligence/_layout/brand-audit'
    | '/dashboard/intelligence/_layout/competitive'
    | '/dashboard/intelligence/_layout/creative-audit'
    | '/dashboard/intelligence/_layout/industry'
    | '/dashboard/intelligence/_layout/overview'
    | '/dashboard/paid-media/_layout/chat'
    | '/dashboard/paid-media/_layout/connectors'
    | '/dashboard/paid-media/_layout/dashboards'
    | '/dashboard/paid-media/_layout/overview'
    | '/dashboard/paid-media/_layout/overview-v3'
    | '/dashboard/paid-media/_layout/playbook'
    | '/dashboard/paid-media/_layout/reports'
    | '/dashboard/paid-media/_layout/schedules'
    | '/dashboard/settings/_layout/invoices'
    | '/dashboard/settings/_layout/profile'
    | '/dashboard/settings/_layout/subscription'
    | '/dashboard/settings/_layout/usage'
    | '/dashboard/consumer-research/_layout/rules/create'
    | '/dashboard/consumer-research/_layout/rules/'
    | '/dashboard/consumer-research/_layout/rules/update/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OnboardingRoute: typeof OnboardingRoute
  AuthRoute: typeof AuthRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
  DashboardsDashboardIdRoute: typeof DashboardsDashboardIdRoute
  ExternalAuthRoute: typeof ExternalAuthRoute
  OauthRoute: typeof OauthRouteWithChildren
  ChatPSessionRoute: typeof ChatPSessionRoute
  ChatRSessionRoute: typeof ChatRSessionRoute
  DashboardsShareShareTokenRoute: typeof DashboardsShareShareTokenRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OnboardingRoute: OnboardingRoute,
  AuthRoute: AuthRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
  DashboardsDashboardIdRoute: DashboardsDashboardIdRoute,
  ExternalAuthRoute: ExternalAuthRoute,
  OauthRoute: OauthRouteWithChildren,
  ChatPSessionRoute: ChatPSessionRoute,
  ChatRSessionRoute: ChatRSessionRoute,
  DashboardsShareShareTokenRoute: DashboardsShareShareTokenRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/onboarding",
        "/auth",
        "/dashboard",
        "/dashboards/$dashboardId",
        "/external/auth",
        "/oauth",
        "/chat/p/$session",
        "/chat/r/$session",
        "/dashboards/share/$shareToken"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/onboarding": {
      "filePath": "onboarding.tsx"
    },
    "/auth": {
      "filePath": "auth",
      "children": [
        "/auth/_layout"
      ]
    },
    "/auth/_layout": {
      "filePath": "auth/_layout.tsx",
      "parent": "/auth",
      "children": [
        "/auth/_layout/",
        "/auth/_layout/callback/google",
        "/auth/_layout/callback/magic-link"
      ]
    },
    "/dashboard": {
      "filePath": "dashboard",
      "children": [
        "/dashboard/_layout",
        "/dashboard/ai-designer",
        "/dashboard/chat/$session",
        "/dashboard/consumer-research",
        "/dashboard/governance",
        "/dashboard/intelligence",
        "/dashboard/paid-media",
        "/dashboard/settings"
      ]
    },
    "/dashboard/_layout": {
      "filePath": "dashboard/_layout.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/_layout/brand",
        "/dashboard/_layout/chats",
        "/dashboard/_layout/community",
        "/dashboard/_layout/library",
        "/dashboard/_layout/market-tracker",
        "/dashboard/_layout/products",
        "/dashboard/_layout/real-time-alerts",
        "/dashboard/_layout/"
      ]
    },
    "/dashboards/$dashboardId": {
      "filePath": "dashboards/$dashboardId.tsx"
    },
    "/external/auth": {
      "filePath": "external/auth.tsx"
    },
    "/oauth": {
      "filePath": "oauth",
      "children": [
        "/oauth/_layout"
      ]
    },
    "/oauth/_layout": {
      "filePath": "oauth/_layout.tsx",
      "parent": "/oauth",
      "children": [
        "/oauth/_layout/facebook",
        "/oauth/_layout/google"
      ]
    },
    "/chat/p/$session": {
      "filePath": "chat/p.$session.tsx"
    },
    "/chat/r/$session": {
      "filePath": "chat/r.$session.tsx"
    },
    "/dashboard/_layout/brand": {
      "filePath": "dashboard/_layout.brand.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/chats": {
      "filePath": "dashboard/_layout.chats.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/community": {
      "filePath": "dashboard/_layout.community.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/library": {
      "filePath": "dashboard/_layout.library.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/market-tracker": {
      "filePath": "dashboard/_layout.market-tracker.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/products": {
      "filePath": "dashboard/_layout.products.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/real-time-alerts": {
      "filePath": "dashboard/_layout.real-time-alerts.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/ai-designer": {
      "filePath": "dashboard/ai-designer",
      "parent": "/dashboard",
      "children": [
        "/dashboard/ai-designer/_layout"
      ]
    },
    "/dashboard/ai-designer/_layout": {
      "filePath": "dashboard/ai-designer/_layout.tsx",
      "parent": "/dashboard/ai-designer",
      "children": [
        "/dashboard/ai-designer/_layout/apps",
        "/dashboard/ai-designer/_layout/create",
        "/dashboard/ai-designer/_layout/library"
      ]
    },
    "/dashboard/chat/$session": {
      "filePath": "dashboard/chat/$session.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/consumer-research": {
      "filePath": "dashboard/consumer-research",
      "parent": "/dashboard",
      "children": [
        "/dashboard/consumer-research/_layout"
      ]
    },
    "/dashboard/consumer-research/_layout": {
      "filePath": "dashboard/consumer-research/_layout.tsx",
      "parent": "/dashboard/consumer-research",
      "children": [
        "/dashboard/consumer-research/_layout/ai-researcher",
        "/dashboard/consumer-research/_layout/brand-moderator",
        "/dashboard/consumer-research/_layout/channels",
        "/dashboard/consumer-research/_layout/overview",
        "/dashboard/consumer-research/_layout/rules",
        "/dashboard/consumer-research/_layout/social-feed",
        "/dashboard/consumer-research/_layout/sub-brands"
      ]
    },
    "/dashboard/governance": {
      "filePath": "dashboard/governance",
      "parent": "/dashboard",
      "children": [
        "/dashboard/governance/_layout"
      ]
    },
    "/dashboard/governance/_layout": {
      "filePath": "dashboard/governance/_layout.tsx",
      "parent": "/dashboard/governance",
      "children": [
        "/dashboard/governance/_layout/compliance-tracker",
        "/dashboard/governance/_layout/creative-monitor",
        "/dashboard/governance/_layout/overview",
        "/dashboard/governance/_layout/performance-benchmark"
      ]
    },
    "/dashboard/intelligence": {
      "filePath": "dashboard/intelligence",
      "parent": "/dashboard",
      "children": [
        "/dashboard/intelligence/_layout"
      ]
    },
    "/dashboard/intelligence/_layout": {
      "filePath": "dashboard/intelligence/_layout.tsx",
      "parent": "/dashboard/intelligence",
      "children": [
        "/dashboard/intelligence/_layout/audience",
        "/dashboard/intelligence/_layout/brand-audit",
        "/dashboard/intelligence/_layout/competitive",
        "/dashboard/intelligence/_layout/creative-audit",
        "/dashboard/intelligence/_layout/industry",
        "/dashboard/intelligence/_layout/overview"
      ]
    },
    "/dashboard/paid-media": {
      "filePath": "dashboard/paid-media",
      "parent": "/dashboard",
      "children": [
        "/dashboard/paid-media/_layout"
      ]
    },
    "/dashboard/paid-media/_layout": {
      "filePath": "dashboard/paid-media/_layout.tsx",
      "parent": "/dashboard/paid-media",
      "children": [
        "/dashboard/paid-media/_layout/chat",
        "/dashboard/paid-media/_layout/connectors",
        "/dashboard/paid-media/_layout/dashboards",
        "/dashboard/paid-media/_layout/overview",
        "/dashboard/paid-media/_layout/overview-v3",
        "/dashboard/paid-media/_layout/playbook",
        "/dashboard/paid-media/_layout/reports",
        "/dashboard/paid-media/_layout/schedules"
      ]
    },
    "/dashboard/settings": {
      "filePath": "dashboard/settings",
      "parent": "/dashboard",
      "children": [
        "/dashboard/settings/_layout"
      ]
    },
    "/dashboard/settings/_layout": {
      "filePath": "dashboard/settings/_layout.tsx",
      "parent": "/dashboard/settings",
      "children": [
        "/dashboard/settings/_layout/invoices",
        "/dashboard/settings/_layout/profile",
        "/dashboard/settings/_layout/subscription",
        "/dashboard/settings/_layout/usage"
      ]
    },
    "/dashboards/share/$shareToken": {
      "filePath": "dashboards/share.$shareToken.tsx"
    },
    "/oauth/_layout/facebook": {
      "filePath": "oauth/_layout.facebook.tsx",
      "parent": "/oauth/_layout"
    },
    "/oauth/_layout/google": {
      "filePath": "oauth/_layout.google.tsx",
      "parent": "/oauth/_layout"
    },
    "/auth/_layout/": {
      "filePath": "auth/_layout.index.tsx",
      "parent": "/auth/_layout"
    },
    "/dashboard/_layout/": {
      "filePath": "dashboard/_layout.index.tsx",
      "parent": "/dashboard/_layout"
    },
    "/auth/_layout/callback/google": {
      "filePath": "auth/_layout.callback.google.tsx",
      "parent": "/auth/_layout"
    },
    "/auth/_layout/callback/magic-link": {
      "filePath": "auth/_layout.callback.magic-link.tsx",
      "parent": "/auth/_layout"
    },
    "/dashboard/ai-designer/_layout/apps": {
      "filePath": "dashboard/ai-designer/_layout.apps.tsx",
      "parent": "/dashboard/ai-designer/_layout"
    },
    "/dashboard/ai-designer/_layout/create": {
      "filePath": "dashboard/ai-designer/_layout.create.tsx",
      "parent": "/dashboard/ai-designer/_layout"
    },
    "/dashboard/ai-designer/_layout/library": {
      "filePath": "dashboard/ai-designer/_layout.library.tsx",
      "parent": "/dashboard/ai-designer/_layout"
    },
    "/dashboard/consumer-research/_layout/ai-researcher": {
      "filePath": "dashboard/consumer-research/_layout.ai-researcher.tsx",
      "parent": "/dashboard/consumer-research/_layout"
    },
    "/dashboard/consumer-research/_layout/brand-moderator": {
      "filePath": "dashboard/consumer-research/_layout.brand-moderator.tsx",
      "parent": "/dashboard/consumer-research/_layout"
    },
    "/dashboard/consumer-research/_layout/channels": {
      "filePath": "dashboard/consumer-research/_layout.channels.tsx",
      "parent": "/dashboard/consumer-research/_layout"
    },
    "/dashboard/consumer-research/_layout/overview": {
      "filePath": "dashboard/consumer-research/_layout.overview.tsx",
      "parent": "/dashboard/consumer-research/_layout"
    },
    "/dashboard/consumer-research/_layout/rules": {
      "filePath": "dashboard/consumer-research/_layout.rules.tsx",
      "parent": "/dashboard/consumer-research/_layout",
      "children": [
        "/dashboard/consumer-research/_layout/rules/create",
        "/dashboard/consumer-research/_layout/rules/",
        "/dashboard/consumer-research/_layout/rules/update/$id"
      ]
    },
    "/dashboard/consumer-research/_layout/social-feed": {
      "filePath": "dashboard/consumer-research/_layout.social-feed.tsx",
      "parent": "/dashboard/consumer-research/_layout"
    },
    "/dashboard/consumer-research/_layout/sub-brands": {
      "filePath": "dashboard/consumer-research/_layout.sub-brands.tsx",
      "parent": "/dashboard/consumer-research/_layout"
    },
    "/dashboard/governance/_layout/compliance-tracker": {
      "filePath": "dashboard/governance/_layout.compliance-tracker.tsx",
      "parent": "/dashboard/governance/_layout"
    },
    "/dashboard/governance/_layout/creative-monitor": {
      "filePath": "dashboard/governance/_layout.creative-monitor.tsx",
      "parent": "/dashboard/governance/_layout"
    },
    "/dashboard/governance/_layout/overview": {
      "filePath": "dashboard/governance/_layout.overview.tsx",
      "parent": "/dashboard/governance/_layout"
    },
    "/dashboard/governance/_layout/performance-benchmark": {
      "filePath": "dashboard/governance/_layout.performance-benchmark.tsx",
      "parent": "/dashboard/governance/_layout"
    },
    "/dashboard/intelligence/_layout/audience": {
      "filePath": "dashboard/intelligence/_layout.audience.tsx",
      "parent": "/dashboard/intelligence/_layout"
    },
    "/dashboard/intelligence/_layout/brand-audit": {
      "filePath": "dashboard/intelligence/_layout.brand-audit.tsx",
      "parent": "/dashboard/intelligence/_layout"
    },
    "/dashboard/intelligence/_layout/competitive": {
      "filePath": "dashboard/intelligence/_layout.competitive.tsx",
      "parent": "/dashboard/intelligence/_layout"
    },
    "/dashboard/intelligence/_layout/creative-audit": {
      "filePath": "dashboard/intelligence/_layout.creative-audit.tsx",
      "parent": "/dashboard/intelligence/_layout"
    },
    "/dashboard/intelligence/_layout/industry": {
      "filePath": "dashboard/intelligence/_layout.industry.tsx",
      "parent": "/dashboard/intelligence/_layout"
    },
    "/dashboard/intelligence/_layout/overview": {
      "filePath": "dashboard/intelligence/_layout.overview.tsx",
      "parent": "/dashboard/intelligence/_layout"
    },
    "/dashboard/paid-media/_layout/chat": {
      "filePath": "dashboard/paid-media/_layout.chat.tsx",
      "parent": "/dashboard/paid-media/_layout"
    },
    "/dashboard/paid-media/_layout/connectors": {
      "filePath": "dashboard/paid-media/_layout.connectors.tsx",
      "parent": "/dashboard/paid-media/_layout"
    },
    "/dashboard/paid-media/_layout/dashboards": {
      "filePath": "dashboard/paid-media/_layout.dashboards.tsx",
      "parent": "/dashboard/paid-media/_layout"
    },
    "/dashboard/paid-media/_layout/overview": {
      "filePath": "dashboard/paid-media/_layout.overview.tsx",
      "parent": "/dashboard/paid-media/_layout"
    },
    "/dashboard/paid-media/_layout/overview-v3": {
      "filePath": "dashboard/paid-media/_layout.overview-v3.tsx",
      "parent": "/dashboard/paid-media/_layout"
    },
    "/dashboard/paid-media/_layout/playbook": {
      "filePath": "dashboard/paid-media/_layout.playbook.tsx",
      "parent": "/dashboard/paid-media/_layout"
    },
    "/dashboard/paid-media/_layout/reports": {
      "filePath": "dashboard/paid-media/_layout.reports.tsx",
      "parent": "/dashboard/paid-media/_layout"
    },
    "/dashboard/paid-media/_layout/schedules": {
      "filePath": "dashboard/paid-media/_layout.schedules.tsx",
      "parent": "/dashboard/paid-media/_layout"
    },
    "/dashboard/settings/_layout/invoices": {
      "filePath": "dashboard/settings/_layout.invoices.tsx",
      "parent": "/dashboard/settings/_layout"
    },
    "/dashboard/settings/_layout/profile": {
      "filePath": "dashboard/settings/_layout.profile.tsx",
      "parent": "/dashboard/settings/_layout"
    },
    "/dashboard/settings/_layout/subscription": {
      "filePath": "dashboard/settings/_layout.subscription.tsx",
      "parent": "/dashboard/settings/_layout"
    },
    "/dashboard/settings/_layout/usage": {
      "filePath": "dashboard/settings/_layout.usage.tsx",
      "parent": "/dashboard/settings/_layout"
    },
    "/dashboard/consumer-research/_layout/rules/create": {
      "filePath": "dashboard/consumer-research/_layout.rules.create.tsx",
      "parent": "/dashboard/consumer-research/_layout/rules"
    },
    "/dashboard/consumer-research/_layout/rules/": {
      "filePath": "dashboard/consumer-research/_layout.rules.index.tsx",
      "parent": "/dashboard/consumer-research/_layout/rules"
    },
    "/dashboard/consumer-research/_layout/rules/update/$id": {
      "filePath": "dashboard/consumer-research/_layout.rules.update.$id.tsx",
      "parent": "/dashboard/consumer-research/_layout/rules"
    }
  }
}
ROUTE_MANIFEST_END */
